// extracted by mini-css-extract-plugin
module.exports = {"subtitle":"MapaDeCalor__subtitle__1wYVv","heatMapWidget":"MapaDeCalor__heatMapWidget__3q0HP"};